export const blogApi = 'https://api.npoint.io/10186ebcfa4796f89303';
